"use strict";
// Please see documentation at https://learn.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.
import './functions.js';
import {onScrollDocument} from "./functions.js";
// Custom events to control page scrolling
// Usage: 
// - To block scroll: document.dispatchEvent(new Event('blockScroll'));
// - To unblock scroll: document.dispatchEvent(new Event('unblockScroll'));
// - To toggle scroll: document.dispatchEvent(new Event('toggleScroll'));

document.addEventListener('toggleScroll', function () {
    document.body.classList.toggle('no-scroll');
});

document.addEventListener('blockScroll', function () {
    document.body.classList.add('no-scroll');
});


/**
 *
 */
document.addEventListener('unblockScroll', function () {
    document.body.classList.remove('no-scroll');
});

/**
 * Adds interaction links to specified div elements by attaching a click event listener.
 * When a div is clicked, it triggers a click action on the first anchor element within the div.
 * The method targets div elements with specific IDs ('services-professionnels', 'services-particuliers', 'recrutement').
 * If the div element is not found, no action is taken for that ID.
 *
 * @return {void} Does not return a value.
 */
function addInteractionLink() {
    let divs = ["services-professionnels", "services-particuliers", "recrutement"];

    divs.forEach(div => {
        let divElement = document.getElementById(div);
        if (divElement) {
            divElement.addEventListener("click", function () {
                this.querySelector("a").click();
            })
        }
    })
}

function addGlobalVariable() {
    window.MAS = {
        urlorigin: window.location.origin,
        urlpage: window.location.href,
        urlpath: window.location.pathname,
        urlbase: window.location.origin + window.location.pathname,
        urlsearch: window.location.search,
    }
}

// Write your JavaScript code.
document.addEventListener('DOMContentLoaded', function () {
    // au chargement de la page, on ajoute la variable globale MAS
    addGlobalVariable();

    document.getElementById("logo").addEventListener("click", function () {
        window.location.href = "/";
    });
    if (document.getElementById("main-nav-phone")) {
        let btn = document.getElementsByClassName("menu-toggle")[0];
        let nav = document.getElementById("main-nav-phone");
        btn.addEventListener("click", function () {
            nav.classList.toggle("active");
            btn.dataset.toggle = btn.dataset.toggle === "collapse" ? "collapsed" : "collapse";
            document.dispatchEvent(new Event('toggleScroll'));
        });
    }

    /** liens de navigation */
    addInteractionLink();
    /** end liens de navigation */

    /** module de scroll sur desktop */
    document.addEventListener('scroll', function () {
        onScrollDocument();
    }, {passive: true});
    /** fin du module de scroll sur desktop */

    /** module de resize */
    document.addEventListener('resize', function () {

    }, {passive: true});
    /** fin du module de resize */

    /** module dropdown */
    const dropdowns = document.querySelectorAll(".dropdown-custom");
    
    dropdowns.forEach((dropdown) => {
        const toggle = dropdown.querySelector(".dropdown-custom__toggle");
        const label = dropdown.querySelector(".dropdown-custom__label");
        const list = dropdown.querySelector(".dropdown-custom__list");
        const items = dropdown.querySelectorAll(".dropdown-custom__item");
        const hiddenInput = dropdown.querySelector('input[type="hidden"]');

        const closeDropdown = () => {
            dropdown.classList.remove("is-open");
            toggle.setAttribute("aria-expanded", "false");
        };

        const openDropdown = () => {
            dropdown.classList.add("is-open");
            toggle.setAttribute("aria-expanded", "true");
        };

        toggle.addEventListener("click", () => {
            const isOpen = dropdown.classList.contains("is-open");
            isOpen ? closeDropdown() : openDropdown();
        });

        items.forEach((item) => {
            item.addEventListener("click", () => {
                items.forEach((el) => el.classList.remove("is-selected"));
                item.classList.add("is-selected");

                label.textContent = item.textContent.trim();
                hiddenInput.value = item.dataset.value;

                // Dispatch custom event for dropdown item selection
                document.dispatchEvent(new CustomEvent('dropdownItemSelected', {
                    detail: {
                        text: item.textContent.trim(),
                        value: item.dataset.value,
                        dropdown: dropdown
                    }
                }));

                closeDropdown();
            });

            item.addEventListener("keydown", (event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    item.click();
                }
            });
        });

        document.addEventListener("click", (event) => {
            if (!dropdown.contains(event.target)) {
                closeDropdown();
            }
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closeDropdown();
            }
        });
    });

    /** fin du module dropdown */

    /** module de la barre de recherche */
        // si un utilisateur écris quelque chose dans la barre de recherche alors il le met directement dans dans les deux champs
    const searchForm = document.querySelector("form[data-name='search']");
    const searchFormSticky = document.querySelector("form[data-name='search-sticky']");
    
    if(searchForm){
        searchForm.querySelector("input").addEventListener("input", function (e) {
            searchFormSticky.querySelector("input").value = e.target.value;
            }
        )
    }
    if(searchFormSticky){
        searchFormSticky.querySelector("input").addEventListener("input", function (e) {
            searchForm.querySelector("input").value = e.target.value;
            }
        )
    }
    /** fin du module de la barre de recherche */
});